import types from './types'
import { groupBy, cloneDeep, every } from 'lodash'

export default {
  [types.getters.areProductsLoaded]: state => ids => {
    return every(ids, id => state.products.some(p => p.key === id) || state.missingProductIds.some(pid => pid === id))
  },
  [types.getters.product]: (state) => (id) => {
    const product = state.products.find(p => p.key === id)
    return (cloneDeep(product) || null)
  },
  [types.getters.groupByCategory]: (state) => (productids) => {
    var products = []
    productids.forEach(productID => {
      var product = state.products.find(p => p.key === productID)
      if (product && product.categories && product.categories.length && product.categories[0].name) {
        products.push(product)
      }
    })
    return groupBy(cloneDeep(products), x => x.categories[0].name)
  }
}
